<template>
	<div class="person">
		<div class="personPic">
			<img :src="mineUrl"/>
			<p>{{name}}</p>
		</div>
		<el-menu :default-active="active" class="el-menu-ver" :router='true'>
		  <el-menu-item index="/person/information"><img src="../assets/img/icon.png"/>个人资料</el-menu-item>
		  <el-menu-item index="/person/submission"><img src="../assets/img/icon.png"/>投稿入口</el-menu-item>
		  <el-menu-item index="/person/manage" :class="{ BlueColor: isBlueColor}"><img src="../assets/img/icon.png"/>投稿管理</el-menu-item>
		  <el-menu-item index="/person/contact"><img src="../assets/img/icon.png"/>联系我们</el-menu-item>
		</el-menu>
		<router-view class="view"></router-view>
		
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapGetters } from 'vuex'
	export default {
	  name: 'Person',
	   data(){
	  	return{
	  		active:'',
	  		picUrl:'',
	  		real_name:'',
	  		mineUrl:''
	  	}
	  },
	  created(){
	  	axios({
	  		method:'post',
	  		url:process.env.BASE_URL+'/user/info',
	  		withCredentials:true
	  	}).then(res =>{
	  		var data = res.data.data
			if(data.avator == null){
		  			this.$store.commit('SET_IMGURL', '/static/admin.png')
		    } else {
		  			this.$store.commit('SET_IMGURL', process.env.PIC_URL + "/" + data.avator)
		  	}
            this.mineUrl = this.$store.state.imgUrl
	  		this.$store.commit('SET_NAME', res.data.data.real_name)
	  		this.$store.commit('SET_ISPERSON', false)
			this.$store.commit('SET_ISLOGIN', false)
			this.$store.commit('SET_ISCENTER', false)
			this.$store.commit('SET_ISFIRST', true)
	  	})
//	  	console.log(isBlueActive)
	  },
	  computed:{
		...mapGetters([
				'imgUrl','name','isBlueColor'
			]),
	   },
	}
</script>

<style scoped>
	.person{
		width: 1000px;
		margin: 0 auto;
		padding-top: 270px;
		
	}
	.personPic{
		width: 114px;
		/*height: 110px;*/
		position: relative;
	}
	.personPic img{
		width: 114px;
		height: 110px;
		z-index: 10;
	}
	.personPic p{
		z-index: 20;		
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		margin: 0 auto;
		text-align: center;
		color: white;
		background-color: black;
	}
	.el-menu-ver{
		border:none;
		width: 120px;
	}
	.el-menu-ver img{
		padding-right: 10px;
	}
	.view{
		width: 850px;
		position: relative;
		margin-left: 150px;
		margin-top: -330px;
		background: #FBFBFB;
	}
</style>


// WEBPACK FOOTER //
// src/views/person.vue